import { motion } from "framer-motion"

type CookieboxType = {
    visible: boolean
    handleAcceptNecessary: () => void
    handleAcceptAll: () => void
}

export default function Cookiebox(props: CookieboxType) {
    return (
        <motion.div
            initial={{
                y: 0,
                opacity: 1,
            }}
            animate={{
                y: !props.visible ? "10%" : 0,
                opacity: !props.visible ? 0 : 1,
            }}
            transition={{
                ease: "linear",
                duration: 0.3,
            }}
            className={`flex fixed bottom-0 left-0 w-full h-fit md:min-h-[20rem] bg-base-200/70 flex-col justify-center p-8 z-40`}>
            <h4 className="text-lg font-bold text-accent underline pb-2">Diese Website nutzt Cookies & Google Analytics!</h4>
            <p className="text-accent text-xs">
                Wir verwenden Cookies und andere Technologien auf unserer Website. Einige von ihnen sind essenziell, während andere uns helfen, diese
                Website und Ihre Erfahrung zu verbessern. Personenbezogene Daten können verarbeitet werden (z. B. IP-Adressen), z. B. für
                personalisierte Anzeigen und Inhalte oder Anzeigen- und Inhaltsmessung. Weitere Informationen über die Verwendung Ihrer Daten finden
                Sie in unserer Datenschutzerklärung. Sie können Ihre Auswahl jederzeit unter Einstellungen widerrufen oder anpassen.
            </p>
            <div className="flex flex-col-reverse justify-center items-center sm:flex-row-reverse w-full sm:justify-between mt-6">
                <button onClick={props.handleAcceptNecessary} className="text-base-300/70 hover:text-white/30 text-sm mr-8 sm:mr-16 md:mr-32">
                    Nur notwendige zulassen
                </button>

                <button
                    onClick={props.handleAcceptAll}
                    className={`bg-primary flex items-center py-3 px-8 rounded-3xl w-fit gap-4 transition-all ease-in duration-300 group border border-transparent hover:bg-base-100 hover:border hover:border-secondary`}>
                    <p className="lowercase text-accent">ich stimme zu</p>
                </button>
            </div>
        </motion.div>
    )
}
